module.exports = __webpack_public_path__ + "static/media/Snubbull_gaussian2.88d209b1.png";